import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { InputNumberInputEvent } from 'primeng/inputnumber';
import { AppConstants } from '../../constants';

@Component({
  selector: 'app-custom-cell-decimal-editor',
  templateUrl: './custom-cell-decimal-editor.component.html',
  styleUrl: './custom-cell-decimal-editor.component.scss'
})
export class CustomCellDecimalEditorComponent implements ICellEditorAngularComp {

  private params: any;
  public value: any;
  maxFractionDigits: number = 4;

  agInit(params: any): void {
    this.params = params;
    this.value = this.params.value;
    if (this.params.dataSourceType) {
      if (this.params.dataSourceType === AppConstants.SeedConversion) {
        this.maxFractionDigits = this.params.values;
      } else {
        this.maxFractionDigits = 4;
      }
    }
  }

  getValue(): any {
    return this.value;
  }
}
